<template>
    <div id="mybookroomcheck">
        <Header />
        <div class="box">
            <div class="container">
                <h1>내 서재</h1>
                <div class="menu">
                    <ul>
                        <li class="on"><a href="#">본 작품</a></li>
                        <li><a href="#">구독한 작품</a></li>
                        <li><a href="#">대여한 작품</a></li>
                        <li><a href="#">소장한 작품</a></li>
                    </ul>
                </div>
                <div class="util">
                    <div>
                        <input class="styled-checkbox no" id="cbxAllAgree" type="checkbox" v-model="checkedAllAgree" @change="allAgree()">
                        <label for="cbxAllAgree">전체선택 - 1개</label>
                    </div>
                    <img src="../assets/images/icon_elimination.svg" alt="휴지통" class="trash">
                    <p class="close">닫기</p>
                </div>
                <div class="row">
                    <div class="col">
                        <div class="check">
                            <input class="styled-checkbox" id="agree1" type="checkbox" v-model="checkedAgree1" @change="agree(1)">
                            <label for="agree1"></label>
                        </div>
                        <div class="check_box on">
                            <img src="../assets/images/hot/col1.webp" alt="썸네일">
                            <div class="text">
                                <p class="name">황제의 약혼녀</p>
                                <p class="writer">김정운</p>
                                <p class="time">방금</p>
                            </div>
                        </div>
                    </div>
                    <div class="col">
                        <div class="check">
                            <input class="styled-checkbox" id="agree2" type="checkbox" v-model="checkedAgree2" @change="agree(2)">
                            <label for="agree2"></label>
                        </div>
                        <div class="check_box">
                            <img src="../assets/images/hot/col1.webp" alt="썸네일">
                            <div class="text">
                                <p class="name">황제의 약혼녀</p>
                                <p class="writer">김정운</p>
                                <p class="time">방금</p>
                            </div>
                        </div>
                    </div>
                    <div class="col">
                        <div class="check">
                            <input class="styled-checkbox" id="agree3" type="checkbox" v-model="checkedAgree3" @change="agree(3)">
                            <label for="agree3"></label>
                        </div>
                        <div class="check_box">
                            <img src="../assets/images/hot/col1.webp" alt="썸네일">
                            <div class="text">
                                <p class="name">황제의 약혼녀</p>
                                <p class="writer">김정운</p>
                                <p class="time">방금</p>
                            </div>
                        </div>
                    </div>
                    <div class="col">
                        <div class="check">
                            <input class="styled-checkbox" id="agree4" type="checkbox" v-model="checkedAgree4" @change="agree(4)">
                            <label for="agree4"></label>
                        </div>
                        <div class="check_box">
                            <img src="../assets/images/hot/col1.webp" alt="썸네일">
                            <div class="text">
                                <p class="name">황제의 약혼녀</p>
                                <p class="writer">김정운</p>
                                <p class="time">방금</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Footer />
    </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'

export default {
    name: 'Home',
        pageCategory: '',
        components: {
            Header,
            Footer,
    },
    data() {
        return{
            checkedAllAgree: false,
            checkedAgree1: false,
            checkedAgree2: false,
            checkedAgree3: false,
            checkedAgree4: false,
        }
    },
    methods: {
        allAgree(){
            this.checkedAgree1 = this.checkedAllAgree;
            this.checkedAgree2 = this.checkedAllAgree;
            this.checkedAgree3 = this.checkedAllAgree;
            this.checkedAgree4 = this.checkedAllAgree;
        },
        agree(no){

            if(this.checkedAllAgree){
                this.checkedAllAgree = false;
            }
            
            if(no === 1){
                if(!this.checkedAgree1){
                    this.checkedAgree1 = false;
                }else{
                    this.checkedAgree1 = true;
                }
            }
            else if(no === 2){
                if(!this.checkedAgree2){
                    this.checkedAgree2 = false;
                }else{
                    this.checkedAgree2 = true;
                }
            }
            else if(no === 3){
                if(!this.checkedAgree3){
                    this.checkedAgree3 = false;
                }else{
                    this.checkedAgree3 = true;
                }
            }
            else if(no === 4){
                if(!this.checkedAgree4){
                    this.checkedAgree4 = false;
                }else{
                    this.checkedAgree4 = true;
                }
            }
        },
    }
}
</script>